import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { isNullOrEmpty, isNullOrUndefined, isNullOrUndefinedNumber } from '../helper/validation';
import { SharedService } from '../helper/shared/shared.service';
import { ProgramSettingsService } from './program-settings.service';
import { UserInfoService } from '../user-info/user-info.service';
import { faToggleOn, faToggleOff} from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router'; //Modified by PP(2023-10-24): Check for timeout of logincode

@Component({
  selector: 'app-program-settings',
  templateUrl: './program-settings.component.html',
  styleUrls: ['./program-settings.component.scss']
})
export class ProgramSettingsComponent implements OnInit {
  Header = "Program Settings";
  ButtonAction = "Save";
  confirmHeading = "Confirmation";
  confirmBody = 'Do you want to save your settings changes?';
  visible = true;
  data: any;
  currency: any;
  unit : any;
  format : any;
  concUnit : any;
  airFlowUnit: any;
  selUnit : number;
  selConcUnitID: number;
  selConcUnit: any;
  selCurrencyName='';
  selFormatId:number;
  selFormat:any;
  selAirFlowUnit: any;
  selUnitName='';
  setco2=0;
  error = true;
  disableFlag=false;
  ISAClassList:any = [{value:1, display:'On'}, {value:0, display:'Off'}];
  //ApplyISAClass = 0;
  showSaveButton = true;

  AirFlowList_US: any;
  AirFlowList_SI: any;

  AirFlowLabel = '';

  constructor(
    private toastr: ToastrService,
    public sharedService: SharedService,
    public programSettingService: ProgramSettingsService,
    private userInfoService: UserInfoService,
    private router: Router //Modified by PP(2023-10-24): Check for timeout of logincode
  ) { }

  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;

  ngOnInit() {
    this.initialize();
    this.sharedService.showSaveButton = this.showSaveButton;
    this.sharedService.VisibleSaveClass = "HideSaveClass";
    this.sharedService.FromProgramSettings = true; //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project
    this.sharedService.UserInfoMode = false;
  }

  initialize(){
    const userId = this.userInfoService.userData.UserId;
    if(userId === 0){
      this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe((response) => {
        if(response !== undefined && response !== null){
          this.userInfoService.InsertUserData(response);
          this.sharedService.RetrieveDDL();
          this.selUnit = this.userInfoService.userData.UserUnitId;
          this.selUnitName = this.userInfoService.userData.UserUnitName;
          this.selConcUnitID = this.userInfoService.userData.UserConcUnitId;
          this.selConcUnit = this.userInfoService.userData.UserConcUnit;
          this.selFormat = this.userInfoService.userData.NumberFormat;
          this.selAirFlowUnit = this.userInfoService.userData.AirFlowUnit;      
        }
      });
    } else {
      this.selUnit = this.userInfoService.userData.UserUnitId;
      this.selUnitName = this.userInfoService.userData.UserUnitName;
      this.selConcUnitID = this.userInfoService.userData.UserConcUnitId;
      this.selConcUnit = this.userInfoService.userData.UserConcUnit;
      this.selFormat = this.userInfoService.userData.NumberFormat;
      this.selAirFlowUnit = this.userInfoService.userData.AirFlowUnit;
    }

    if (this.selConcUnitID === undefined) {
      this.selConcUnitID = 1;
      this.selConcUnit = 'ppb';
    }

    if(this.selUnit == 2)
    {
      this.disableFlag=true;
    }


    //Modified by PP(2023-05-03) : Program Settings sometimes empty if(this.selUnit !== 0 && (this.format===undefined || this.unit===undefined || this.concUnit===undefined || this.airFlowUnit===undefined)) {
    if (this.selUnit !== 0) { //Modified by PP(2023-05-03) : Program Settings sometimes empty
      //if (this.programSettingService.unitList === undefined || this.programSettingService.formatList === undefined) {
      if (this.programSettingService.unitList === undefined || this.programSettingService.concUnitList === undefined || this.programSettingService.airFlowUnit_SI === undefined || this.programSettingService.airFlowUnit_US === undefined || this.programSettingService.formatList === undefined) {
        console.log("PS20230321 Check: => fetch program settings -START => "   + new Date());
        this.programSettingService.getData(this.selUnit).subscribe((result) => {
          console.log("PS20230321 Check: => fetch program settings -END=> "   + new Date());
          if(result!==undefined && result!==null){
            //Modified by JW(2021-12-15): share unitlist, conclist and formatlist among programsetting page, new project and cleanroom pop up-start
            // this.format = result.Selection.FormatList;
            // this.unit = result.Selection.UnitsList;
            // this.concUnit = result.Selection.ConcentrationUnitList;
            this.programSettingService.formatList = result.Selection.FormatList;
            this.programSettingService.unitList = result.Selection.UnitsList;
            //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) this.programSettingService.concUnitList = result.Selection.ConcentrationUnitList;
  
            this.AirFlowList_SI = result.Selection.FlowRateList_SI.List;
            this.AirFlowList_US = result.Selection.FlowRateList_US.List;
            
            switch(this.selUnit) {
              case 1:
                this.programSettingService.airFlowUnitList = result.Selection.FlowRateList_SI.List;
                if (this.selAirFlowUnit == "" || this.selAirFlowUnit == null) {
                  this.selAirFlowUnit = result.Selection.FlowRateList_SI.DefaultValue;
                }
  
                //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - START
                this.programSettingService.concUnitList = result.Selection.ConcentrationUnitList_SI.List;
                if (this.selConcUnit == "" || this.selConcUnit == null) {
                  this.selConcUnit = result.Selection.ConcentrationUnitList_SI.List.DefaultValue;
                }
                //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - END
  
                //AirFlow Label
                this.AirFlowLabel = 'Airflow (m³/h / CFM / m³/s / L/s)';
                break;
  
              case 2:
                this.programSettingService.airFlowUnitList = result.Selection.FlowRateList_US.List;
                if (this.selAirFlowUnit == "" || this.selAirFlowUnit == null) {
                  this.selAirFlowUnit = result.Selection.FlowRateList_US.DefaultValue;
                }
              
                //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - START
                this.programSettingService.concUnitList = result.Selection.ConcentrationUnitList_US.List;
                if (this.selConcUnit == "" || this.selConcUnit == null) {
                  this.selConcUnit = result.Selection.ConcentrationUnitList_US.List.DefaultValue;
                }
                //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - END
  
                //AirFlow Label
                this.AirFlowLabel = 'Airflow (CFM)';
                break;
            }          
            //Modified by JW(2021-12-15): share unitlist, conclist and formatlist among programsetting page, new project and cleanroom pop up-end
          } else {
            this.userInfoService.userData.UserId = 0;
            this.toastr.error('Session time out. Please login again.', '');
            this.router.navigate(["login"]); 
          }
        });
      } else {
        this.AirFlowList_SI = this.programSettingService.airFlowUnit_SI.List;
        this.AirFlowList_US = this.programSettingService.airFlowUnit_US.List;

        switch(this.selUnit) {
          case 1:
            this.programSettingService.airFlowUnitList = this.programSettingService.airFlowUnit_SI.List;
            if (this.selAirFlowUnit == "" || this.selAirFlowUnit == null) {
              this.selAirFlowUnit = this.programSettingService.airFlowUnit_SI.DefaultValue;
            }

            this.programSettingService.concUnitList = this.programSettingService.concUnit_SI.List;
            if (this.selConcUnit == "" || this.selConcUnit == null) {
              this.selConcUnit = this.programSettingService.concUnit_SI.DefaultValue;
            }

            this.AirFlowLabel = 'Airflow (m³/h / CFM / m³/s / L/s)';
            break;

          case 2:
            this.programSettingService.airFlowUnitList = this.programSettingService.airFlowUnit_US.List;
            if (this.selAirFlowUnit == "" || this.selAirFlowUnit == null) {
              this.selAirFlowUnit = this.programSettingService.airFlowUnit_US.DefaultValue;
            }

            this.programSettingService.concUnitList = this.programSettingService.concUnit_US.List;
            if (this.selConcUnit == "" || this.selConcUnit == null) {
              this.selConcUnit = this.programSettingService.concUnit_US.DefaultValue;
            }

            this.AirFlowLabel = 'Airflow (CFM)';
            break;
        }
      }
    } else { //if (this.selUnit !== 0)
      console.log("In Program Settings this.selUnit==0 => "   + new Date());
    }
  }

  showDataFromChild(data:any){
    if(isNullOrUndefinedNumber(this.selUnit) || isNullOrUndefinedNumber(this.selConcUnitID) || isNullOrUndefinedNumber(this.selFormat)){
      this.error = true;
      this.toastr.warning('Please fill all the fields', '');
    }
    else{
      this.error =false;
    }
    if(!this.error){
      this.selConcUnitID = this.programSettingService.getSelectedConcId(this.selConcUnit);
      this.selFormatId = this.programSettingService.getSelectedFormatId(this.selFormat);
      this.programSettingService.postData(this.selUnit,this.selConcUnitID, this.selFormatId, this.selAirFlowUnit).subscribe(res => {
        this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe(res => {
          this.userInfoService.userData.UserId = 0;
          this.initialize();
          this.sharedService.FromProgramSettings = false; //Modified by PP(2023-02-28) : If click on new project then go back to Home -> Program settings, title becomes Untitled Project
          this.toastr.success('Settings saved', '');
        });
     });
   }
  }

  toggleUnit() {
    if(this.selUnit === 2){
      //AirFlow Unit
      this.selAirFlowUnit = 'CFM';   
      this.programSettingService.airFlowUnitList = this.AirFlowList_US;
      this.disableFlag = true;

      //AirFlow Label
      this.AirFlowLabel = 'Airflow (CFM)'

      //Concentration Unit
      //this.selConcUnit = 'ppb';    
      //this.disableFlag = true;
    }
    else { 
      //AirFlow Unit
      this.programSettingService.airFlowUnitList = this.AirFlowList_SI;
      this.selAirFlowUnit = 'm³/h';
      this.disableFlag = false;

      //AirFlow Label
      this.AirFlowLabel = 'Airflow (m³/h / CFM / m³/s / L/s)'

      //Concentration Unit      
      //this.disableFlag = false;
    }
  }

}
